import React from 'react';
import ReactTooltip from 'react-tooltip';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Spinner } from 'react-bootstrap';
// @ts-expect-error Will convert later
import Loader from '../../Loader/Loader';

import FlagTree from './ModalContent/FlagTree';

import { useBulletinMessages } from '../../../context/bulletin-messages';
import { useBulletin, useBulletinResponse } from '../../../context/bulletin';
import { useGetBulletinMessage } from '../../../services/api';

interface MessagesReviewModalProps {
  closeAction: () => void;
  show: boolean;
  onValidate: () => void;
}

const MessagesReviewModal = ({
  closeAction,
  show,
  onValidate,
}: MessagesReviewModalProps) => {
  const { bulletinType, bulletinDate } = useBulletin();
  const bulletinResponse = useBulletinResponse();
  const { hasErrors, isLoading } = useBulletinMessages();

  const messagesQuery = useGetBulletinMessage(bulletinType, bulletinDate, show);

  const helpTextValidation =
    'Before sending the confirmation you can edit messages about maps or any other bulletin items.<br/>Once confirmed, the bulletin cannot be edit edited anymore.<br/>If you cancel all your additional comments will be lost.';

  const helpTextConsultation =
    "The daily report has already been validated. You can consult the report here but can't modify it anymore.";

  function getContent() {
    if (messagesQuery?.isFetching) {
      return <Loader>Loading bulletin messages...</Loader>;
    }
    if (messagesQuery?.isError) {
      return <p>Error loading bulletin messages</p>;
    }
    if (messagesQuery?.data) {
      return <FlagTree bulletinMessages={messagesQuery.data} />;
    }
    return null;
  }

  const isErrorPresent = hasErrors
    ? Object.values(hasErrors).some(v => v === true)
    : false;

  const isDataLoading = isLoading
    ? Object.values(isLoading).some(v => v === true)
    : false;

  return (
    <Modal show={show} onHide={closeAction} size="lg" centered>
      <Modal.Header>
        {!bulletinResponse.bulletin.isValidated ? (
          <h2>
            Validation of the daily bulletin
            <span
              data-tip={helpTextValidation}
              data-for="help"
              className="icon-info-circle"
            />
          </h2>
        ) : (
          <h2>
            Report of the daily bulletin
            <span
              data-tip={helpTextConsultation}
              data-for="help"
              className="icon-info-circle"
            />
          </h2>
        )}
        <ReactTooltip
          id="help"
          place="top"
          type="dark"
          effect="solid"
          delayHide={1500}
          multiline
        />
      </Modal.Header>
      <Modal.Body>{getContent()}</Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-primary"
          data-cy="validate-bulletin-discard-button"
          onClick={closeAction}
        >
          Close
        </Button>
        <div
          data-tip={
            isErrorPresent ? 'Please fix all errors before validating.' : ''
          }
          data-for="modal_cannot_validate"
        >
          <Button
            data-cy="validate-bulletin-button"
            onClick={onValidate}
            disabled={
              isDataLoading ||
              isErrorPresent ||
              messagesQuery?.isLoading ||
              messagesQuery?.isError
            }
          >
            {isDataLoading && (
              <span style={{ paddingRight: 6 }}>
                <Spinner animation="border" role="status" size="sm">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </span>
            )}
            Confirm validation
          </Button>
        </div>
        <ReactTooltip
          id="modal_cannot_validate"
          effect="solid"
          delayHide={1500}
          className="smalltooltip"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default MessagesReviewModal;
